import Checkbox from "react-custom-checkbox";
import blueCheck from "../images/newDesign/blueCheck.svg";

export function SquareCheckbox({ labelFontWeight='bold', ...props}) {
  return <Checkbox
    borderColor="rgba(111, 139, 255, 0.4)"
    borderStyle="solid"
    borderWidth={1}
    borderRadius={0}
    icon={<img src={blueCheck} alt="check" draggable={false} />}
    labelStyle={{
      fontFamily: 'Arimo, sans-serif', // FIXME: use styles and global css-variables
      fontWeight: labelFontWeight,
      fontSize: 14,
      textAlign: 'start',
    }}
    {...props}
  />
}
